import React from 'react';
import PropTypes from 'prop-types';

import { texts } from 'utils/languages/fr';
import { CustomTextField } from 'components';
import { InputAdornment } from '@mui/material';
import * as icons from 'mdi-material-ui';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    quickSearch: {
        marginBottom: 0,
    },
    clearIcon: {
        fontSize: 20,
        color: theme.palette.grey[400],
        cursor: 'pointer',
    },
}));

const QuickSearchField = props => {
    const { handleClear, ...rest } = props;
    const classes = useStyles();

    return (
        <CustomTextField
            {...rest}
            inputStyle={classes.quickSearch}
            placeholder={texts.QUICK_SEARCH}
            endAdornment={
                <InputAdornment position="start" onClick={handleClear}>
                    <icons.Close className={classes.clearIcon} />
                </InputAdornment>
            }
        />
    );
};

QuickSearchField.propTypes = {
    handleClear: PropTypes.func.isRequired,
};

export default QuickSearchField;
